<template>
    <div class="box">
        <div class="content-container">
            <div class="left-content-box" v-infinite-scroll="load">
                <no-data v-if="tableData.length == 0"></no-data>
                <div v-for="(item, index) in tableData" class="left-item"
                    :class="{ 'active-item': item.id == currentId }" @click="changeTask(item)" :key="index">
                    <p class="task-name">{{ item.examineName }}</p>
                        <div class="label-status"
                            :style="`background-color:${filterTaskStatus(item.examineStatus).color||'rgba(245, 108, 108,0.8)'};`">{{
                                filterTaskStatus(item.examineStatus).label||'未考' }}</div>
                        <el-tooltip effect="dark" :content="'答题详情'" placement="top-start">
                            <img class="detail-img" v-if="(item.examineStatus=='2')&&!isTimeArea(item.beginTime,item.endTime)" @click="viewScoreDetail(item)"
                                src="../../../assets/image/person/detail.png" alt="">
                        </el-tooltip>
                    </div>
                    <div class="bottom-content">
                        <div class="item">
                            <p>考核类型：</p>
                            <p>{{ examineTypeOpt[item.examineType]||'' }}</p>
                        </div>
                    <div class="item">
                        <p>开始时间：</p>
                        <p>{{ item.beginTime }}</p>
                    </div>
                    <div class="item">
                        <p>结束时间：</p>
                        <p>{{ item.endTime }}</p>
                    </div>
                    <div style="display: flex;justify-content: space-between;">
                        <div class="item">
                        <p>总分：</p>
                        <el-tooltip effect="dark" :disabled="!(item.fullScore.toString())"
                            :content="item.fullScore.toString()" placement="top-start">
                            <p class="overflow" style="width: 5rem;">{{ item.fullScore }}</p>
                        </el-tooltip>
                    </div>
                    <div class="item">
                        <p>及格分：</p>
                        <p>{{ item.passScore }}</p>
                    </div>
                    </div>
                </div>
            </div>
            <div class="right-content-box">
                <Table :totalSize="listData.length" style="width: 100%;" :pagination="false" :operationWidth="350" :currentPage="pages.current"
                :pageSize="pages.size" navHeight=40 ref="table" :tableData="tableData" :tableKey="tableKey">
                <template slot="operation" slot-scope="data">
                    <div class="btn-button disable-button" v-if="['0','3'].includes(data.data.row.examineStatus)&&isTimeArea(data.data.row.beginTime, data.data.row.endTime)">开始任务</div>
                    <div class="btn-button" v-else-if="['1', null].includes(data.data.row.examineStatus)&&isTimeArea(data.data.row.beginTime, data.data.row.endTime)"
                        @click="startTask(data.data.row)">开始任务</div>
                    <div class="btn-button" v-else-if="!isTimeArea(data.data.row.beginTime, data.data.row.endTime)"
                        @click="viewScoreDetail(data.data.row)">查看详情</div>
                </template>
                <template slot="type" slot-scope="data">
                    <div>{{ filterType[data.data.row.type] }}</div>
                </template>
            </Table>
            </div>
        </div>
        <start-task ref="start_task"></start-task>
        <all-start-task ref="all_start_task"></all-start-task>
        <choose-software ref="choose_software"></choose-software>
        <theory-detail :detail="detail" ref="theory_detail"></theory-detail>
    </div>
</template>

<script>
import { PageExamineStd, GetExamineDetailById, GetExaminePaperId, QueryExamineDetailById } from '@/api/examine';
import StartTask from './StartTask.vue';
import { GetTestPaperQuestion, GetUserAnswerRecord } from '@/api/paper';
import { isTimeArea } from '@/utils/utils';
import { filterTaskStatus } from '@/utils/utils';
import ExamineTree from '../../backendSys/examineMag/virtual/ExamineTree.vue';
import ChooseSoftware from './ChooseSoftware.vue';
import TheoryDetail from './TheoryDetail.vue';
import AllStartTask from './AllStartTask.vue';
export default {
    components: { StartTask, ExamineTree, ChooseSoftware, TheoryDetail, AllStartTask },
    props: ['name', 'examineType', 'examineStatus'],
    data() {
        return {
            pages: {
                current: 1,
                size: 10,
                total: 0
            },
            filterType: {
                0: '理论',
                1: '软件'
            },
            tableData: [],
            listData:[],
            currentId:'',
            tableKey: [
                {
                    name: '考核名称',
                    value: 'examineName',
                },
                {
                    name: '考核类型',
                    value: 'examineType',
                    slot: 'examineType'
                },
                {
                    name: '开始时间',
                    value: 'beginTime'
                },
                {
                    name: '结束时间',
                    value: 'endTime'
                },
                {
                    name: '',
                    value: 'operation',
                    slot: 'operation'
                },
            ],
            detail: {},
            paperId: ''
        }
    },
    methods: {
        isTimeArea(start, end) {
            return isTimeArea(start, end);
        },
        load(){
            let total = this.pages.current * this.pages.size;
            if (total >= this.pages.total) return;
            this.pages.current++;
            this.pageExamineStd();
        },
        filterTaskStatus,
        /**获取用户答题记录 */
        getUserAnswerRecord(examineId) {
            return new Promise(resolve => {
                var params = {
                    "businessId": examineId + '-' + this.paperId,
                    "testPaperId": this.paperId,
                    "testPaperSource": 'examine_paper'
                }
                GetUserAnswerRecord(params).then(async (res) => {
                    if (res.code == 200) {
                        this.recordId = res.data.id;
                        await this.getTestPaperQuestion(examineId);
                        this.$set(this.detail, 'userQuestionScoreVOS', res.data.userQuestionScoreVOS);
                        let startTime = new Date(res.data.startTime).getTime();
                        let endTime = new Date(res.data.endTime).getTime();
                        let userTestTime = (endTime - startTime) / 1000;
                        this.$set(this.detail, 'userTestTime', userTestTime);
                        let questionDetailVOS = this.detail.questionDetailVOS;
                        res.data.userQuestionScoreVOS && res.data.userQuestionScoreVOS.forEach(item => {
                            var data = questionDetailVOS[item.questionType];
                            var userAnswer = item.userAnswer || [];
                            if (data) {
                                let e = data.find(el => el.questionId == item.questionId);
                                if (e) {
                                    this.$set(e, 'correctAnswer', item.correctAnswer || []);
                                    this.$set(e, 'score', item.score || 0);
                                    this.$set(e, 'content', item.content || '暂无');
                                    var questionType = item.questionType;
                                    if (questionType == '多选题') {
                                        e.value = userAnswer;
                                    } else if (questionType == '填空题') {
                                        e.questionOptionVOS.forEach((a, b) => {
                                            a.value = userAnswer[b] ? userAnswer[b] : '';
                                        })
                                    } else {
                                        e.value = userAnswer[0] ? userAnswer[0] : '';
                                    }
                                }
                            }
                        })
                        resolve(res.data);
                    }
                })
            })
        },
        /**获取试卷题目数据 */
        getTestPaperQuestion(examineId) {
            return new Promise(resolve => {
                var params = {
                    "businessId": examineId + '-' + this.paperId,
                    "testPaperId": this.paperId,
                    "testPaperRecordId": this.recordId
                }
                GetTestPaperQuestion(params).then(res => {
                    if (res.code == 200) {
                        var questionDetailVOS = res.data.questionDetailVOS;
                        var i = 1;
                        for (let key in questionDetailVOS) {
                            questionDetailVOS[key].orderIndex = i;
                            i++;
                            questionDetailVOS[key] && questionDetailVOS[key].forEach(item => {
                                if (key == '多选题') {
                                    item.value = [];
                                    return;
                                } else if (key == '填空题') {
                                    item.questionOptionVOS && item.questionOptionVOS.forEach(el => {
                                        el.value = '';
                                    })
                                } else {
                                    item.value = '';
                                }
                            })
                        }
                        this.detail = res.data;
                        let dialog = this.$refs.theory_detail;
                        if (dialog) {
                            dialog.dialogVisible = true;
                        }
                        resolve(res.data);
                    }
                })
            })
        },
        pageExamineStd() {
            let params = {
                "current": this.pages.current,
                "examineName": this.name,
                "examineStatus": this.examineStatus,
                "examineType": this.examineType,
                "size": this.pages.size
            };
            PageExamineStd(params).then(res => {
                if (res.code == 200) {
                    if (this.pages.current == 1) {
                        this.tableData = res.data.records;
                    } else {
                        this.tableData = [...this.tableData, ...res.data.records];
                    }
                    this.pages.total = res.data.total;
                    if (this.tableData.length > 0 && !this.currentId) {
                        this.currentId = this.tableData[0].id;
                        this.changeTask(this.tableData[0]);
                    }
                }
            })
        },
        /**模糊查询 */
        search() {
            this.pages.current = 1;
            this.pageExamineStd();
        },
        /**开始任务 */
        changeTask(data) {
            // if (!isTimeArea(data.beginTime, data.endTime)) return;
            if (data.examineType == '1') {
                GetExamineDetailById({ id: data.id }).then(res => {
                    if (res.code == 200) {
                        this.listData=res.data.softwareDetailList || [];
                    }
                })
            } else if (data.examineType == '2') {
                QueryExamineDetailById({ id: data.id }).then(res => {
                    if (res.code == 200) {
                        let arr1 = res.data.softwareDetailList.map(item => {
                                return {
                                    type: '1',
                                    id: item.id,
                                    name: item.softwareName,
                                    softwareCode: item.softwareCode,
                                    examineStatus: item.examineStatus,
                                    beginTime: data.beginTime,
                                    endTime: data.endTime,
                                    url: item.url,
                                    resType: item.resType
                                }
                            });
                            let arr2 = res.data.paperDetailList.map(item => {
                                return {
                                    type: '0',
                                    id: item.id,
                                    name: item.testPaperName,
                                    examineStatus: item.examineStatus,
                                    beginTime: data.beginTime,
                                    endTime: data.endTime,
                                }
                            })
                            dialog.listData = [...arr1, ...arr2];
                    }
                })
            } else {
                this.getExaminePaperId(data.id).then((paperId) => {
                    var href = window.location.origin + `/theoryTest?id=${paperId}&examineId=${data.id}`;
                    window.open(href, '_blank');
                })
            }
        },
        /**通过考核id获取理论试卷(组合) */
        getExaminePaperId(id) {
            return new Promise((resolve) => {
                GetExaminePaperId({ id }).then(res => {
                    if (res.code == 200) {
                        resolve(res.data);
                    }
                })
            })
        },
        /**查看得分详情 */
        viewScoreDetail(data) {
            if (data.examineType == '1') {
                GetExamineDetailById({ id: data.id }).then(res => {
                    if (res.code == 200) {
                        let dialog = this.$refs.choose_software;
                        if (dialog) {
                            dialog.dialogVisible = true;
                            dialog.taskId = data.id;
                            dialog.optSource = 'sp_examine';
                            dialog.tableData = res.data.softwareDetailList || [];
                        }
                    }
                })
            } else if (data.examineType == '2') {
                QueryExamineDetailById({ id: data.id }).then(res => {
                    if (res.code == 200) {
                        let dialog = this.$refs.all_start_task;
                        if (dialog) {
                            dialog.dialogVisible = true;
                            dialog.taskId = data.id;
                            dialog.optSource = 'sp_examine';
                            let arr1 = res.data.softwareDetailList.map(item => {
                                return {
                                    type: '1',
                                    id: item.id,
                                    name: item.softwareName,
                                    softwareCode: item.softwareCode,
                                    examineStatus: item.examineStatus,
                                    url: item.url,
                                    beginTime: data.beginTime,
                                    endTime: data.endTime,
                                    resType: item.resType
                                }
                            });
                            let arr2 = res.data.paperDetailList.map(item => {
                                return {
                                    type: '0',
                                    id: item.id,
                                    name: item.testPaperName,
                                    beginTime: data.beginTime,
                                    endTime: data.endTime,
                                    examineStatus: item.examineStatus
                                }
                            })
                            dialog.tableData = [...arr1, ...arr2];
                        }
                    }
                })
            } else {
                this.getExaminePaperId(data.id).then((paperId) => {
                    this.paperId = paperId;
                    this.getUserAnswerRecord(data.id);
                })
            }
        },
        changeCurrentPage(e) {
            this.pages.current = e;
            this.pageExamineStd();
        },
        changePageSize(e) {
            this.pages.size = e;
            this.pages.current = 1;
            this.pageExamineStd();
        },
    },
    mounted() {
        this.search();
    },
    watch: {
        examineStatus() {
            this.search();
        },
        examineType() {
            this.search();
        }
    }
}
</script>

<style lang="less" scoped>
.box {
    height: 100%;
}

.btn-button {
    width: 72px;
    height: 25px;
    color: #ffffff;
    background-color: var(--blue);
    border-radius: 0.6rem;
    display: flex;
    font-size: 14px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

/deep/th {
    background-color: #ffffff !important;
}

.disable-button {
    cursor: not-allowed !important;
    background-color: #C0C4CC !important;
}

.no-test {
    color: red;
}


.content-container {
    height: calc(100% - 5rem);
    display: flex;
}


.table-item {
    border-bottom: 1px solid #e0e8f2;
    padding: 2.4rem 3.7rem 2.2rem 6.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.task-name {
    font-weight: 700;
    font-size: 16px;
}

.label-status {
    padding: 0.2rem 0;
    width: 4.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.4rem 0px 0.4rem 0px;
    color: #ffffff;
    margin-left: 14px;
}

.top-content {
    display: flex;
}

.bottom-content {
    margin-top: 12px;
    display: flex;
    font-size: 14px;
    color: #8590B3;

    &> :nth-child(n) {
        margin-left: 4.5rem;
    }

    &> :nth-child(1) {
        margin-left: 0;
    }
}

.item {
    display: flex;
}

.page-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
}

.detail-img {
    width: 2.1rem;
    margin-left: 1rem;
    cursor: pointer;
}
.left-content-box {
    width: 30rem;
    height: 100%;
    overflow: auto;
    background-color: #ffffff;
    .left-item {
        padding: 2rem;
        border-bottom: 1px solid #e0e8f2;
        cursor: pointer;

        .task-name {
            font-weight: 700;
            font-size: 16px;
        }
    }
}

.active-item {
    background-color: var(--blue) !important;
    color: #ffffff !important;
}

.right-content-box {
    width: calc(100% - 35rem);
    height: 100%;
    margin-left: 5rem;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    overflow: auto;
}
/deep/.table{
    height: 100%;
}
</style>